import CustomCheckboxesWidget from "./Checkboxes"

export default CustomCheckboxesWidget
